export default __webpack_public_path__ + "static/media/pot2.d253f902.svg";